


























































import StringPairs from "~/types/StringPairs";
import SvgIcon from "~/components/partials/SvgIcon.vue";
import Triangles from "~/components/partials/Triangles.vue";
import { emailAddress, urls } from "~/constants";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "Header",

  components: {
    SvgIcon,
    Triangles,
  },

  props: {},

  setup() {
    const socialLinks: {
      icon: string;
      attributes: StringPairs;
      svgAttributes: StringPairs;
    }[] = [
      {
        icon: "Github",
        attributes: {
          href: urls.githubProfile,
          title: "My Github profile",
        },
        svgAttributes: {
          title: "My Github profile",
        },
      },
      {
        icon: "LinkedIn",
        attributes: {
          href: urls.linkedInProfile,
          title: "My LinkedIn profile",
        },
        svgAttributes: {
          title: "My LinkedIn profile",
        },
      },
      {
        icon: "Twitter",
        attributes: {
          href: urls.twitterProfile,
          title: "My Twitter timeline",
        },
        svgAttributes: {
          title: "My Twitter timeline",
        },
      },
    ];

    // Implement best security practices for external links.
    socialLinks.forEach(link => (link.attributes.rel = "noopener"));

    return {
      emailAddress,
      socialLinks,
    };
  },
});
